import { GridLayout, Page, PageBanner, StyledParagraph } from "@components/general";
import { Grid } from "@material-ui/core";
import { color } from "@resources/styles";
import { useTranslation } from "@utils/i18n";
import NextFCPage from "@utils/types";
import React from "react";

const TermsAndConditions: NextFCPage = () => {
  const { t } = useTranslation(["terms-and-conditions"]);
  return (
    <Page>
      <PageBanner title={t("title")} />
      <GridLayout section justify="center">
        <Grid item xs={10}>
          <StyledParagraph color={color.black} component="div" dangerouslySetInnerHTML={{ __html: t("content") }} />
        </Grid>
      </GridLayout>
    </Page>
  );
};

TermsAndConditions.ageVerification = false;

export default TermsAndConditions;
